import { useState } from "react";
import * as React from "react";
import { ButtonProps } from "./Button";

export const withLoadingOnAction =
    (ButtonComponent: React.ComponentType<ButtonProps>) =>
    ({ action, ...props }: ButtonProps) => {
        const [isLoading, setIsLoading] = useState(false);

        const act: ButtonProps["action"] = React.useCallback(
            e => {
                setIsLoading(true);
                action(e);
            },
            [setIsLoading, action]
        );

        return <ButtonComponent {...props} isLoading={isLoading} action={act} />;
    };
